import strappedConnected from "modules/Core/higher-order-components/strappedConnected";
import cells from "modules/auth/state";
import LegalLayout from "../../LegalLayout";

const SECTIONS = [
    {
        id: "privacy",
        title: "Privacy Policy",
        highlight: true,
        content: (
            <p>
                How we collect, use, store and protect your personal information is set out in our{" "}
                <a href="/privacy">Privacy Policy</a>. To delete your account and data, see{" "}
                <a href="/delete-account">Delete your account</a>.
            </p>
        ),
    },
    {
        id: "refunds",
        title: "Refund & Cancellation Policy",
        content: (
            <p>
                You may request a refund within 7 days of purchase. Subscriptions can be canceled anytime via email or
                within your user dashboard.
            </p>
        ),
    },
    {
        id: "terms",
        title: "Terms & Disclaimer",
        content: (
            <p>
                By using this service, you agree to our terms. We provide services as-is and are not liable for misuse or
                failure outside our control.
            </p>
        ),
    },
];

const PoliciesPage = ({ isAuthed }) => (
    <LegalLayout
        isAuthed={isAuthed}
        eyebrow="Legal"
        title="Policies"
        sections={SECTIONS}
    />
);

export default strappedConnected(
    PoliciesPage,
    { isAuthed: cells.validateToken.selectors.isAuthed },
    {},
    () => ({})
);
